/**
 * Register the Genelco service worker.
 * The SW itself is safe in dev — it uses network-first for navigations and
 * static assets, and never intercepts the dev-server WebSocket (ws://). If
 * you need to disable it locally, unregister via DevTools > Application > SW.
 */
export function registerSW() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        reg.update && reg.update();
      })
      .catch((err) => {
        // Non-fatal — app still works without SW
        console.warn("SW registration failed:", err);
      });
  });
}
